<script lang="ts" setup></script>

<template>
  <div class="grid-header font-size-12 bg-white font-weight-600 text-grey-darken-1">
    <slot></slot>
  </div>
</template>

<style lang="scss">
@import "@/assets/style/color";

.grid-header {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: subgrid;
  border-bottom: 1px solid $grey-lighter;
  margin-bottom: 8px;

  div {
    padding: 12px 16px;
    border-left: 1px solid $grey-lighter;
    height: 100%;
    align-content: center;
  }
}
</style>
